export const accordionContent = [
    {
        title: "Session 1: Introduction to Programming",
        body: [
            "Understanding Computer Operations",
            "The Essence of Programming",
            "Varieties of Programming Languages",
            "Strategies for Problem-Solving.",
            "Introduction to Control Flow.",
            "Tackling Real-World Issues with Flow Charts and Pseudo Code."
        ]
    },
    {
        title: "Session 2: Getting Started with C - I",
        body: [
            "Hello World",
            "Keyword & Identifier",
            "Variables & Constants",
            "Data Types",
            "Input/Output",
            "Comments"
        ]
    },
    {
        title: "Session 3: Getting Started with C - II",
        body: [
            "Operators",
            "Practicals"
        ]
    },
    {
        title: "Session 4: Flow Control - I",
        body: [
            "If…else",
            "Switch…case",
            "Ternary"
        ]
    },
    {
        title: "Session 5: Flow Control - II",
        body: [
            "Nested if",
            "Practicals"
        ]
    },
    {
        title: "Session 6: Flow Control - III",
        body: [
            "For Loop",
            "While Loop"
        ]
    },
    {
        title: "Session 7: Flow Control - IV",
        body: [
            "Flow Controls - break, continue, and goto",
            "Nested Loops"
        ]
    },
    {
        title: "Session 8: Functions - I",
        body: [
            "Standard Functions",
            "User-defined Functions",
            "Function Types"
        ]
    },
    {
        title: "Session 9: Functions - II",
        body: [
            "Recursion",
            "Storage Class"
        ]
    },
    {
        title: "Session 10: Project I",
        body: [
            "Practicals & Project"
        ]
    },
    {
        title: "Session 11: Arrays",
        body: [
            "Arrays"
        ]
    },
    {
        title: "Session 12: Multi-dimensional Arrays",
        body: [
            "Multi-dimensional Arrays"
        ]
    },
    {
        title: "Session 13: Arrays & Functions",
        body: [
            "Arrays & Functions"
        ]
    },
    {
        title: "Session 14: Project II",
        body: [
            "Practicals & Project"
        ]
    },
    {
        title: "Session 15: Strings",
        body: [
            "String",
            "String Functions"
        ]
    },
    {
        title: "Session 16: Pointers",
        body: [
            "Pointers"
        ]
    },
    {
        title: "Session 17: Pointers & Arrays",
        body: [
            "Pointers & Arrays"
        ]
    },
    {
        title: "Session 18: Pointers & Functions",
        body: [
            "Pointers & Functions",
            "Memory Allocation"
        ]
    },
    {
        title: "Session 19: Project III",
        body: [
            "Practicals & Project"
        ]
    },
    {
        title: "Session 20: Structure",
        body: [
            "Structure",
            "Struct & Pointers"
        ]
    },
    {
        title: "Session 21: Structure - II",
        body: [
            "Struct & Functions",
            "Unions"
        ]
    },
    {
        title: "Session 22: Project - IV",
        body: [
            "Practicals & Project"
        ]
    },
    {
        title: "Session 23: File Handling",
        body: [
            "Files Input/Output"
        ]
    },
    {
        title: "Session 24: Project - V",
        body: [
            "Practicals & Project"
        ]
    }
];

